import { isNil } from '@lucidlink/tscore';
class StatEntry {
    name;
    key;
    current;
    committed;
    constructor(name, key, current = 0n, committed = 0n) {
        this.name = name;
        this.key = key;
        this.current = current;
        this.committed = committed;
    }
    isDirty() {
        return this.current !== this.committed;
    }
}
export class StatsAccumulator {
    provider;
    metaStore;
    tuple;
    log;
    statsName;
    entries = new Map();
    constructor(provider, metaStore, tuple, log, statsName) {
        this.provider = provider;
        this.metaStore = metaStore;
        this.tuple = tuple;
        this.log = log;
        this.statsName = statsName;
    }
    async load() {
        this.log.trace(`Fetching ${this.statsName} ...`);
        const it = await this.metaStore.getIterator(this.provider.getRange());
        for (const kv of it) {
            const id = this.provider.toStatId(kv.key);
            const entry = isNil(id) ? undefined : this.entries.get(id);
            if (isNil(entry)) {
                continue;
            }
            const fetchedValue = this.tuple.getUint64FromTuple(kv.value, 0);
            if (entry.isDirty()) {
                this.log.error(`Fetching dirty ${this.statsName}! name:${entry.name} current:${entry.current} committed:${entry.committed} fetched:${fetchedValue}`);
            }
            entry.current = fetchedValue;
            entry.committed = fetchedValue;
        }
        this.log.trace(`Fetching ${this.statsName} finished`);
    }
    getBatch() {
        const records = [];
        const values = [];
        for (const [id, entry] of this.entries) {
            if (entry.isDirty()) {
                values.push([id, entry.current]);
                records.push({ key: entry.key, value: this.provider.toValue(entry.current) });
            }
        }
        return { records, values };
    }
    applyCommitted(values) {
        for (const [id, value] of values) {
            const entry = this.entries.get(id);
            if (!isNil(entry)) {
                entry.committed = value;
            }
        }
    }
    setupStat(id, name, key) {
        this.entries.set(id, new StatEntry(name, key, 0n, 0n));
    }
    increment(id, value) {
        const entry = this.entries.get(id);
        entry.current += BigInt(value);
    }
    currentOf(id) {
        return this.entries.get(id).current;
    }
    committedOf(id) {
        return this.entries.get(id).committed;
    }
}
